import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { RepositoriesService } from "@service/repositories.service";
import { InvitationsService } from '@service/invitations.service';

import { Paginate } from "@model/Paginate";
import { Repository } from "@model/Repository";
import { PageEvent } from "@angular/material";
import { Project } from "@model/Project";

@Component({
  selector: 'app-modal-repositories',
  templateUrl: './modal-repositories.component.html',
  styleUrls: ['./modal-repositories.component.scss']
})
export class ModalRepositoriesComponent implements OnInit {

  @ViewChild('searchInput', { read: ElementRef, static: false }) searchInput: ElementRef;
  @ViewChild('formRepo', { read: ElementRef, static: false }) formRepo: ElementRef;
  @Input() private invitation: any;

  public repoId: string = '';
  public repoName: string = '';

  private subscription: Subscription = new Subscription();
  term: string = '';
  repositories: Paginate<Repository> = null;

  loading: boolean = true;

  private is_author = null;

  public pageEvent: PageEvent;
  public page: Paginate<Project> = {
    page: 20,
    current: 0,
    total: 0
  } as Paginate<Project>;
  public pageSizeOptions: number[] = [5, 10, 20];

  constructor(
    public activeModal: NgbActiveModal,
    private readonly repositoriesService: RepositoriesService,
    private readonly invitationsService: InvitationsService,
  ) {}

  ngOnInit(): void {
    this.is_author = this.invitation.role === 'Autor';
    this.pageEvent = this.getData({
      previousPageIndex: 0,
      pageIndex: this.page.current,
      pageSize: this.page.page,
      length: this.page.total
    });
  }

  getData(event?: PageEvent): PageEvent {
    this.repositoriesService.paginate(event.pageSize, event.pageIndex + 1, this.term, this.is_author)
      .subscribe((repositories: Paginate<Repository>) => {
        this.page = {...this.page, total: repositories.total};
        this.repositories = repositories;
        this.loading = false;
      }, () => this.loading = false);
    return event;
  }

  public get isRepositoriesEmpty(): boolean {
    return this.repositories === null || this.repositories.data.length === 0;
  }

  private formRepoContainsHideClass(): boolean {
    return this.formRepo.nativeElement.classList.contains('hide-form');
  }

  selectRepoHandler() {
    if (!this.formRepoContainsHideClass()) {
      this.formRepo.nativeElement.classList.add('hide-form');
    }
  }

  addRepo() {
    document.getElementsByName('repos').forEach(repoRadio => {
      // @ts-ignore
      repoRadio.checked = false;
    });

    if (this.formRepoContainsHideClass()) {
      this.formRepo.nativeElement.classList.remove('hide-form');
    } else {
      this.formRepo.nativeElement.classList.add('hide-form');
    }
  }

  inviteHandler() {
    if (!this.formRepoContainsHideClass()) {
      if (this.repoName) {
        const repository = {
          name: this.repoName,
          description: this.repoName,
          projects: [this.invitation.project_id],
          is_author: this.is_author,
        };

        // this.submitted = false;

        console.log('invitation', this.invitation, repository);
        this.invitationsService.accept(this.invitation.id).subscribe(() => {
          this.repositoriesService.store(repository).subscribe(() => {
            this.activeModal.close();
          });
        });
      }
    } else {
      const repo = this.repositories.data.find(repo => repo.id === Number(this.repoId));
      const projectsIds = repo.projects.map(p => p.id);
      repo.projects = [...projectsIds, this.invitation.project_id];
      repo.is_author = this.is_author;
      console.log('repo', repo);
      this.invitationsService.accept(this.invitation.id).subscribe(() => {
        this.repositoriesService.update(parseInt(this.repoId, 10), repo)
          .subscribe(() => {
            this.activeModal.close();
          });
      });
    }
  }
}
